import { ButtonV2 } from '@findy-code/yuffie/ui/button/v2';
import { Tooltip } from '@findy-code/yuffie/ui/tooltip';
import { useState } from 'react';
import { FaRegThumbsUp } from 'react-icons/fa';

import type { HandleClickLikeParams } from '../../../types';

type Props = {
  disabledMessage?: string;
  isSent?: boolean;
  jobDescription: { id: number; jdHash: string };
  // ButtonV2 反映時に整備する
  variant?: 'secondary';
  onClick?: (params: HandleClickLikeParams) => void;
};

export const LikeButton = ({
  disabledMessage,
  isSent = false,
  jobDescription,
  variant,
  onClick,
}: Props) => {
  // memo:
  // useJobDescriptionFacade の handleClickLike 内でもAPI呼び出し中の状態管理をしているが、
  // その状態はLoadingScrim用に別途使われている。なのでボタンの状態に関係するAPI呼び出し中の状態をこちらでも管理する
  // また onClick は useMutation であり、当コンポーネントでそれを try catch することはできないので
  // 意図せず 当コンポーネントの disabled 状態が続いてしまうこともあるため、onError 時のコールバックを当コンポーネントから渡す作りにしている
  const [isPending, setIsPending] = useState(false);

  return (
    <span
      data-tooltip-content={disabledMessage}
      data-tooltip-id={`like-button-disabled-message-${jobDescription.id}`}
    >
      <ButtonV2
        disabled={!!disabledMessage || isSent || isPending}
        startIcon={FaRegThumbsUp}
        type="button"
        variant={variant}
        onClick={() => {
          setIsPending(true);
          onClick?.({
            jdHash: jobDescription.jdHash,
            jdId: jobDescription.id,
            isLikedFromUser: !!disabledMessage || isSent,
            onErrorCallback: () => setIsPending(false),
          });
        }}
      >
        {isSent ? 'いいかも済み' : 'いいかも'}
      </ButtonV2>
      {!!disabledMessage && (
        <Tooltip id={`like-button-disabled-message-${jobDescription.id}`} />
      )}
    </span>
  );
};
